import type { ComponentPropsWithoutRef } from 'react'

// before/afterの×印はabsoluteのボタン自身を基準に配置される
const ModalCloseButton = ({ className = '', ...props }: ComponentPropsWithoutRef<'button'>) => (
  <button
    className={`absolute -top-5 -right-5 h-10 w-10 rounded-[2em] border-3 border-white bg-gray-900 before:absolute before:top-2 before:right-4 before:block before:h-[18px] before:w-[3px] before:rotate-45 before:bg-white before:content-[''] after:absolute after:top-2 after:right-4 after:block after:h-[18px] after:w-[3px] after:-rotate-45 after:bg-white after:content-[''] ${className}`}
    {...props}
  />
)

export default ModalCloseButton
